import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Reports = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ sx, ...props }, ref) => (
    <SvgIcon
      viewBox="0 0 25 24"
      {...props}
      sx={{ fill: 'none', ...(sx || {}) }}
      ref={ref}
    >
      <path
        d="M12.209 2C13.5222 2 14.8226 2.25866 16.0358 2.76121C17.2491 3.26375 18.3515 4.00035 19.2801 4.92893C20.2086 5.85752 20.9452 6.95991 21.4478 8.17317C21.9503 9.38643 22.209 10.6868 22.209 12M12.209 2V12M12.209 2C6.68614 2 2.20898 6.47715 2.20898 12C2.20898 17.5228 6.68614 22 12.209 22C17.7318 22 22.209 17.5229 22.209 12M12.209 2C17.7318 2 22.209 6.47716 22.209 12M22.209 12L12.209 12M22.209 12C22.209 13.5781 21.8355 15.1338 21.119 16.5399C20.4026 17.946 19.3635 19.1626 18.0868 20.0902L12.209 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
);

Reports.displayName = 'Reports';
